import React from 'react';
import moment from 'moment';
import {
  Container,
  Header,
  Segment,
  Icon,
  Image,
  Grid,
  Step,
  Button,
  Card,
  Label,
  Table,
  Dimmer,
  List
} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import DivWrapper from './DivWrapper';

import {FormattedMessage} from 'react-intl';
import appPreview from '../img/app_preview.png';
import Counter from './Counter';

import applePic from '../img/apple-badge.png';
import googlePlayPic from '../img/google-play-badge.png';

import { BACKGROUND_DARK, BACKGROUND_DARK2, PRIMARY_COLOR } from '../constants';
import AudoryCoinIcon from '../img/AudoryCoinIcon';

const PageHeader = ({mobile}) => (
    <Segment 
        inverted
        textAlign='center'
        style={{ padding: '0em 0em' }}
        vertical
      >
      <Container text style={{padding: '5em 0em'}}>
        <Header
            as='h1'
            inverted
            style={{
            fontSize: mobile ? '1.2em' : '2.5em',
            fontWeight: 'normal',
            marginBottom: 0,
            }}
        >
            <FormattedMessage id="audory.responsiveContainer.body.career.headText"/>
        </Header>
        <Header
            as='h2'
            inverted
            style={{
            fontSize: mobile ? '1.5em' : '1.5em',
            fontWeight: 'normal',
            }}
        >
            <FormattedMessage id="audory.responsiveContainer.body.career.bodyText"/>
        </Header>
        
        </Container>
    </Segment>
)

class CareerPage extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            audioSrc: null,
            audio: {},
            activePay: null,
        };
    }


    render(){
        /*
<Header as='h3' style={{ fontSize: '2em', marginTop: '2em' }}>
                      <FormattedMessage id="audory.temp.4"/>
                    </Header>
        */
        return (
            <DivWrapper>
                <PageHeader />
              <Segment style={{ padding: '3em 0em', margin: 0 }}>
                  
                  <Container text>
                    <Header as='h2' style={{ fontSize: '2.8em', marginBottom: '0.5em' }}>
                        Werde Teil unseres Teams
                    </Header>
                    <p style={{ fontSize: '1.33em', textAlign: 'justify'}}>
                        Ganz egal ob du noch zur Schule gehst, einen Schul- oder Hochschulabschluss hast oder du dich bisher auf einen Ausbildungsplatz konzentriert hast: Wir suchen dich, wenn du zur Arbeit gehst weil du es willst und nicht, weil du musst!
                        Erzähle uns über dich und nicht nur über deinen beruflichen Status. Was machst du für Projekte in deiner Freizeit? Hast du ein Portfolio oder andere Referenzen? Wir sind flexibel und finden von Minijob bis Vollanstellung genau das Richtige für dich.
                    </p>
                    <center>
                        <Image bordered rounded size='huge' src='https://audory-static.s3.eu-central-1.amazonaws.com/career.jpg' />
                    </center>
                    

                    <Header as='h2' style={{ fontSize: '2.8em', marginTop: '1em', marginBottom: '0.5em' }}>
                        Aktuelle Jobs
                    </Header>
                    <List divided relaxed>
                        <List.Item>
                            <List.Icon name='laptop' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header>Softwareentwickler (m/w/d)</List.Header>
                                <List.Description>Backend, Frontend, JavaScript, React, Node</List.Description>
                            </List.Content>
                        </List.Item>

                        <List.Item>
                            <List.Icon name='cart' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header>Vertriebsleiter (m/w/d) - Region Sachsen</List.Header>
                                <List.Description>B2B, B2C, Messen</List.Description>
                            </List.Content>
                        </List.Item>

                        <List.Item>
                            <List.Icon name='laptop' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header>Mediengestalter (m/w/d) - Region Sachsen</List.Header>
                                <List.Description>Cutting, SocialMedia, Creative work</List.Description>
                            </List.Content>
                        </List.Item>


{
    /*
                        <List.Item>
                            <List.Icon name='microphone' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header as='a' target='_blank' href="https://www.texthungrig.com/interview-mit-max-rose">Interview bei texthungrig</List.Header>
                                <List.Description as='a'>"Interaktive Hörspiele sind die Musik der Zukunft"</List.Description>
                            </List.Content>
                        </List.Item>
    */
}
                        
                    </List>

                    <p style={{ fontSize: '1.33em', textAlign: 'justify'}}>
                        Nichts dabei und du glaubst trotzdem, dass wir dich brauchen? Dann schreibe uns!
                    </p>
          
                      <Header as='h2' style={{ fontSize: '2.8em', marginTop: '1em' }}>
                          Bewerbung
                      </Header>
                      <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                        Schicke eine Mail mit deinem Portfolio oder deine anderen Referenzen an <a style={{color: PRIMARY_COLOR}} target='_blank' href="mailto:max.rose@audory.de?subject=Job%20als%20%3CJOB%3E%20bei%20audory&body=Lieber%20Max%2C%0D%0A%0D%0Aunter%20%3CLink%3E%20findest%20du%20mein%20Portfolio...%0D%0A%0D%0AIn%20meiner%20Freizeit...%0D%0AWenn%20Geld%20keine%20Rolle%20mehr%20spielen%20w%C3%BCrde%2C%20w%C3%BCrde%20mein%20Alltag%20wie%20folgt%20aussehen...%0D%0A%0D%0ABeste%20Gr%C3%BC%C3%9Fe%0D%0A%3CNAME%3E">max.rose@audory.de</a>.
                        Bitte erzähle von deinen Projekten und was du mit deiner Freizeit anfängst. Wie würde dein Alltag aussehen, wenn Geld keine Rolle mehr spielen würde?
                      </p>

                    <center>
                        <a target='_blank' href={"mailto:max.rose@audory.de?subject=Job%20als%20%3CJOB%3E%20bei%20audory&body=Lieber%20Max%2C%0D%0A%0D%0Aunter%20%3CLink%3E%20findest%20du%20mein%20Portfolio...%0D%0A%0D%0AIn%20meiner%20Freizeit...%0D%0AWenn%20Geld%20keine%20Rolle%20mehr%20spielen%20w%C3%BCrde%2C%20w%C3%BCrde%20mein%20Alltag%20wie%20folgt%20aussehen...%0D%0A%0D%0ABeste%20Gr%C3%BC%C3%9Fe%0D%0A%3CNAME%3E"}>
                            <Button labelPosition='right' icon='mail' size='huge' content='E-Mail schreiben' />
                        </a>
                    </center>

                          
                  </Container>
              </Segment>
            </DivWrapper>
          );
    }
} 



export default CareerPage;


// WEBPACK FOOTER //
// ./src/components/CareerPage.js